import { MenuSection } from '@invessio/ui';
import { PermissionService } from '../globalServices/permission.service';
import { FeatureFlagService } from '../globalServices/feature-flag.service';

export const SIDEBAR_MENU_CONFIG: MenuSection[] = [
  {
    heading: 'Navigation',
    get items() {
      const allItems = [
        // {
        //   label: 'Dashboard',
        //   route: '/dashboard',
        //   openIcon: 'DashboardIcon',
        //   closeIcon: 'DashboardIcon',
        // },
        {
          label: 'Dashboard',
          route: '/students/analytics-dashboard',
          openIcon: 'DashboardIcon',
          closeIcon: 'DashboardIcon',
          isExpanded: true,
        },
        {
          label: 'Application Management',
          route: '/students/student-management',
          openIcon: 'ManageStudentsIcon',
          closeIcon: 'ManageStudentsIcon',
          isExpanded: true,
          // children: [
          //   {
          //     label: 'Invitations',
          //     route: '/students/invitations',
          //     openIcon: '',
          //     closeIcon: '',
          //   },
          //   {
          //     label: 'Application',
          //     route: '/students/applications',
          //     openIcon: '',
          //     closeIcon: '',
          //   },
          // {
          //   label: 'Prospects',
          //   route: '/students/prospects',
          //   openIcon: '',
          //   closeIcon: '',
          // },
          // ],
        },
        {
          label: 'Provider Management',
          route: 'school-management/provider-management',
          openIcon: 'ProviderManagementIcon',
          closeIcon: 'ProviderManagementIcon',
          isExpanded: true,
        },
        // {
        //   label: 'School Management',
        //   route: '', // Parent item without direct route
        //   openIcon: 'SchoolManagementIcon',
        //   closeIcon: 'SchoolManagementIcon',
        //   isExpanded: true,
        //   children: [
        //     // {
        //   label: 'Activity',
        //   route: '/school/activity',
        //   openIcon: '',
        //   closeIcon: '',
        // },
        // {
        //   label: 'Applications',
        //   route: '/offer-details/applications',
        //   openIcon: '',
        //   closeIcon: '',
        // },
        // {
        //   label: 'Programs',
        //   route: '/school/programs',
        //   openIcon: '',
        //   closeIcon: '',
        // },
        //   ],
        // },
        // {
        //   label: 'Access Logs',
        //   route: '', // Parent item without direct route
        //   openIcon: 'AccessLogIcon',
        //   closeIcon: 'AccessLogIcon',
        //   isExpanded: true,
        //   children: [
        //     {
        //       label: 'SSN',
        //       route: '/access-logs/ssn',
        //       openIcon: '',
        //       closeIcon: '',
        //     },
        //     {
        //       label: 'Account Number',
        //       route: '/access-logs/account-number',
        //       openIcon: '',
        //       closeIcon: '',
        //     },
        //   ],
        // },
        // {
        //   label: 'Users',
        //   route: '/users',
        //   openIcon: 'UsersIcon',
        //   closeIcon: 'UsersIcon',
        // },
        {
          label: 'Task Management',
          route: '/tasks',
          openIcon: 'TasksIcon',
          closeIcon: 'TasksIcon',
        },
        {
          label: 'Refunds',
          route: '/refunds',
          openIcon: 'RefundsIcon',
          closeIcon: 'RefundsIcon',
        },
      ];

      return allItems.filter(item => {
        if (item.label === 'Task Management') {
          return (
            PermissionService.isOperationsAdmin &&
            FeatureFlagService.isFlagEnabled('TaskManagement')
          );
        }
        if (item.label === 'Dashboard') {
          // Ignyte admin: AnalyticsDashboard. School admin: AnalyticsDashboardSchool.
          if (PermissionService.isOperationsAdmin) {
            return FeatureFlagService.isFlagEnabled('AnalyticsDashboard');
          }
          return FeatureFlagService.isFlagEnabled('AnalyticsDashboardSchool');
        }
        if (item.label === 'Refunds') {
          return FeatureFlagService.isFlagEnabled('RefundManagement');
        }
        if (item.label === 'Provider Management') {
          return (
            PermissionService.isOperationsAdmin &&
            FeatureFlagService.isFlagEnabled('SchoolProfileManagement')
          );
        }
        return true;
      });
    },
  },
];
